import { StateToken } from '@ngxs/store';
import type { TableStateModel } from './table-state.model';

export const TABLE_STATE_TOKEN = new StateToken<TableStateModel<any>>('table');
